import type {
  EstimationItemResponse,
  EstimationModelResponse,
  MethodologyResponse,
} from '@/api/schema/data-contracts';
import { EstimationCalculator } from '@/utils/calculations/EstimationCalculator';

import type { EstimationItemsFormModelRow, RecalculateCallback } from '../../model';
import * as estimationItemsForCalculationMapper from './estimationItemsForCalculationMapper';

export const prepareRecalculate =
  (
    estimationItems: EstimationItemResponse[],
    estimationModel: EstimationModelResponse,
    methodologies: MethodologyResponse[],
    estimationMethodologyId: string,
  ): RecalculateCallback =>
  (formModelEstimationItems: EstimationItemsFormModelRow[]) => {
    const estimationItemsForCalculation =
      estimationItemsForCalculationMapper.getEstimationItemsForCalculation(
        estimationItems,
        estimationModel,
        methodologies,
        estimationMethodologyId,
        formModelEstimationItems,
      );

    const estimationCalculator = new EstimationCalculator(estimationModel, methodologies);
    const calculatedResultByEstimationItemId = estimationCalculator.recalculateEstimations(
      estimationItemsForCalculation,
    );

    return calculatedResultByEstimationItemId;
  };
